import React from 'react';
import { styled } from '@mui/material/styles';
import {
  AppBar,
  Typography,
  TableCell,
  TableRow,
  TextField,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import EnhancedTablePagination from './EnhancedTablePagination';
import {Auth} from '../../Api/auth';
import Snackbar from '../CommonComponents/Snackbar';

import { useMsal } from "@azure/msal-react";

const PREFIX = 'HistoriesList';

const classes = {
  select: `${PREFIX}-select`,
  appBarHeader: `${PREFIX}-appBarHeader`,
  backdrop: `${PREFIX}-backdrop`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.select}`]: {
    width: '25%',
  },

  [`& .${classes.appBarHeader}`]: {
    color: theme.palette.text.primary,
    background: 'white',
    position: 'static',
    top: 0,
    left: 'auto',
    width: '100%',
    padding: theme.spacing(2, 1, 1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

export default function HistoriesList() {

  const {instance}=useMsal();

  const [historyData, setHistoryData] = React.useState({
    history: null,
    rows: [],
    headCells: [],
    maxRows: 0,
    resetOrder: true
  });

  let tables = {
    "history": "History table",
    "historyUserProject": "History user project table",
  }

  const setPageRequestData=(history, page, rowsPerPage, orderBy, order)=>{
    let urlParams = new URLSearchParams({"page": page+1, "perPage": rowsPerPage, "sortColumn": orderBy, "sortOrder": order});
    var url=(history=="history"?"getHistories":"getUserProjectHistories")
   
     return Auth.authorizedFetch("/api/"+url + "?" + urlParams.toString(),{},instance)
      .then((response)=> {
        if(!response.ok){
          setSnackbarState({open: true, severity: "error", message: response.statusText});
          throw Error(response.statusText)
        }
        
        return response.json();
      });
  }

  const getPageRequestData=(history, page, rowsPerPage, orderBy, order)=>{
    setBackdropOpen(true);

    let promise=setPageRequestData(history, page, rowsPerPage, orderBy, order)

    promise.then((data)=>{
      setHistoryData({
        history: history,
        rows: data.data,
        headCells: getHeadCells(history),
        maxRows: data.maxRequests
      });
    })
    .finally(()=>{
      setBackdropOpen(false);
    });

  }


  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    severity: "success",
    message: ""
  });
  const [backdropOpen, setBackdropOpen] = React.useState(false);

  /*const getRowsPromiseForHistory=(url)=>{
    return Auth.authorizedFetch("/api/"+url,{},instance)
    .then((response)=> {
      if(!response.ok){
        setSnackbarState({open: true, severity: "error", message: response.statusText});
        throw Error(response.statusText)
      }
      
      return response.json();
    });
  }*/

  const getRowsPromise=(value)=>{
    return setPageRequestData(value,0,10,"dateCreated","desc")
  }

  const getHeadCells=(value)=>{
    switch(value){
      case "history":
        return [
          {id: 'dateCreated', label: "Date created", isOrderable: true},
          {id: 'request', label: "Request", isOrderable: true},
          {id: 'status', label: "Status", isOrderable: true},
          {id: 'assignStatusId', label: "Assigned status id", isOrderable: true},
          {id: 'assignedUserId', label: "Assigned user id", isOrderable: true},
          {id: 'user', label: "User", isOrderable: true},
          {id: 'role', label: "Role", isOrderable: true},
          {id: 'billableHours', label: "Billable hours", isOrderable: true},
          {id: 'billableMinutes', label: "Billable minutes", isOrderable: true}
        ];
      case "historyUserProject":
        return [
          {id: 'dateCreated', label: "Date created", isOrderable: true},
          {id: 'user', label: "User", isOrderable: true},
          {id: 'project', label: "Project", isOrderable: true},
          {id: 'role', label: "Role", isOrderable: true},
          {id: 'userProjectAction', label: "User project action", isOrderable: true}
        ];
      default:
        return [];
    }
  }

  const handleChange=(value)=>{

    setHistoryData({
      history: value,
      rows: [],
      headCells: getHeadCells(value),
      maxRows: 0
    });

    //setBackdropOpen(true);
    //let promise = getRowsPromise(value);

      /*
    promise.then((data)=>{
      setHistoryData({
        history: value,
        rows: data.data,
        headCells: getHeadCells(value),
        maxRows: data.maxRequests,
        resetOrder: true
      });
      
    })
    .finally(()=>{
      setBackdropOpen(false);
    });

    */
  }
  
  const getTableRow=(row)=>{
    switch(historyData.history){
      case "history":
        return (
          <TableRow key={row.id}>
            <TableCell component="th" scope="row">{row.dateCreated}</TableCell>
            <TableCell>{row.request}</TableCell>
            <TableCell>{row.status}</TableCell>
            <TableCell>{row.assignStatusId}</TableCell>
            <TableCell>{row.assignedUserId}</TableCell>
            <TableCell>{row.user}</TableCell>
            <TableCell>{row.role}</TableCell>
            <TableCell>{row.historyBillableTime && row.historyBillableTime.billableHours}</TableCell>
            <TableCell>{row.historyBillableTime && row.historyBillableTime.billableMinutes}</TableCell>
          </TableRow>
        );
      case "historyUserProject":
        return (
          <TableRow key={row.id}>
            <TableCell component="th" scope="row">{row.dateCreated}</TableCell>
            <TableCell>{row.user}</TableCell>
            <TableCell>{row.project}</TableCell>
            <TableCell>{row.role}</TableCell>
            <TableCell>{row.userProjectAction}</TableCell>
          </TableRow>
        );
      default:
        return <Root></Root>;
    }
  }

  return (
    <>
      <AppBar
        className={classes.appBarHeader}
        elevation={0}
      >
        <Typography
          variant="h6"
          component="h1"
        >
          View Histories
        </Typography>
      </AppBar>
      <Autocomplete
        id="history-select"
        className={classes.select}
        style={{marginTop: 8, marginBottom:4}}
        options={Object.keys(tables)}
        getOptionLabel={(option)=>tables[option]}
        renderInput={(params) => (
          <TextField
            {...params}
            multiline
            rows="1"
            label="History"
            variant="outlined"
          />
        )}
        value={historyData.history}
        onChange={(event, newValue) => {
          handleChange(newValue);
        }}
        disableClearable={true}
      />
      {historyData.history !== null &&
        <EnhancedTablePagination
          headCells={historyData.headCells}
          rows={historyData.rows}
          getTableRow={getTableRow}
          getPageRequestData={getPageRequestData}
          historyType={historyData.history}
          maxRows={historyData.maxRows}
        />
      }
      <Backdrop className={classes.backdrop} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar 
        message={snackbarState.message}
        severity={snackbarState.severity}
        open={snackbarState.open}
        handleClose={()=>{setSnackbarState({...snackbarState, open: false, message: ""})}}
      />
    </>
  );
}